import Vue from "vue";

export const readerDebugLock = Vue.observable({
  active: false,
});

let lastWarnAt = 0;

export function warnReaderDebugLocked(notify) {
  const now = Date.now();
  if (now - lastWarnAt < 1500) return;
  lastWarnAt = now;
  if (typeof notify === "function") notify();
}
